
import { defineComponent } from 'vue'
import { iOlapFilter } from '@/modules/documentExecution/olap/Olap'
import toolbarDescriptor from './OlapFilterToolbarDescriptor.json'

export default defineComponent({
    components: {},
    props: { olapProp: { type: Object, required: true } },
    emits: ['openSidebar', 'putFilterOnAxis', 'swapAxis', 'switchPosition', 'showMultiHierarchy', 'openFilterDialog'],
    computed: {
        showScroll(): Boolean {
            return this.scrollContainerWidth < this.scrollContentWidth
        }
    },
    data() {
        return {
            toolbarDescriptor,
            columns: [] as iOlapFilter[],
            rows: [] as iOlapFilter[],
            cutArray: [12, 11, 10, 9, 6],
            scrollContainerWidth: 0,
            scrollContentWidth: 0
        }
    },
    watch: {
        olapProp() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
        window.addEventListener('resize', this.assignScrollValues)
        this.assignScrollValues()
    },
    methods: {
        loadData() {
            this.columns = this.olapProp?.columns as iOlapFilter[]
            this.rows = this.olapProp?.rows as iOlapFilter[]
        },
        cutName(name, axis, multi) {
            var ind = axis
            if (multi) ind = ind + 2
            ind = ind + 1
            var cutProp = this.cutArray[ind]
            if (name == undefined) {
                name = '...'
            }
            if (name.length <= cutProp) return name
            else return name.substring(0, cutProp) + '...'
        },
        onDragStart(event, filter, filterId) {
            event.dataTransfer.setData('text', JSON.stringify(filter))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            // @ts-ignore
            this.$refs[`${filterId}`].classList.add('filter-dragging')
        },
        removeDragClass(filterId) {
            // @ts-ignore
            this.$refs[`${filterId}`].classList.remove('filter-dragging')
        },
        displayDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.add('display-axis-dropzone')
        },
        hideDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
        },
        onDrop(event) {
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
            var data = JSON.parse(event.dataTransfer.getData('text/plain'))

            var leftLength = this.rows.length
            var topLength = this.columns.length
            var fromAxis
            if (data != null) {
                fromAxis = data.axis
                if (fromAxis != 0) {
                    if (data.axis === 1 && leftLength == 1) {
                        this.$store.commit('setInfo', { title: this.$t('common.toast.warning'), msg: this.$t('documentExecution.olap.filterToolbar.dragEmptyWarning') })
                    } else {
                        data.positionInAxis = topLength
                        data.axis = 0
                        this.$emit('putFilterOnAxis', fromAxis, data)
                    }
                }
            }
            setTimeout(() => {
                this.assignScrollValues()
            }, 100)
        },
        scrollLeft() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollLeft -= 50
        },
        scrollRight() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollLeft += 50
        },
        assignScrollValues() {
            // @ts-ignore
            this.scrollContainerWidth = this.$refs?.filterPanelContainer?.clientWidth - 83
            // @ts-ignore
            this.scrollContentWidth = this.$refs?.filterItemsContainer?.scrollWidth
        },
        openFilterDialog(filter: any) {
            this.$emit('openFilterDialog', { filter: filter, type: 'visible' })
        }
    }
})
